module.exports = __webpack_public_path__ + "img/wide.82267cf2.jpg";